
export const defaultFavorites = new Set([
	"basic-latin",
	"latin-1-supplement",
	"latin-extended-a",
	"latin-extended-b",
	"ipa-extensions",
	"spacing-modifier-letters",
	"combining-diacritical-marks",
	"greek-and-coptic",
	"cyrillic",
	"cyrillic-supplement",
	"hebrew",
	"combining-diacritical-marks-extended",
	"cyrillic-extended-c",
	"phonetic-extensions",
	"phonetic-extensions-supplement",
	"combining-diacritical-marks-supplement",
	"latin-extended-additional",
	"greek-extended",
	"general-punctuation",
	"superscripts-and-subscripts",
	"currency-symbols",
	"combining-diacritical-marks-for-symbols",
	"letterlike-symbols",
	"number-forms",
	"arrows",
	"mathematical-operators",
	"miscellaneous-technical",
	"control-pictures",
	"optical-character-recognition",
	"enclosed-alphanumerics",
	"box-drawing",
	"block-elements",
	"geometric-shapes",
	"miscellaneous-symbols",
	"dingbats",
	"miscellaneous-mathematical-symbols-a",
	"supplemental-arrows-a",
	"braille-patterns",
	"supplemental-arrows-b",
	"miscellaneous-mathematical-symbols-b",
	"supplemental-mathematical-operators",
	"miscellaneous-symbols-and-arrows",
	"latin-extended-c",
	"cyrillic-extended-a",
	"supplemental-punctuation",
	"ideographic-description-characters",
	"cjk-symbols-and-punctuation",
	"enclosed-cjk-letters-and-months",
	"cjk-compatibility",
	"yijing-hexagram-symbols",
	"cyrillic-extended-b",
	"modifier-tone-letters",
	"latin-extended-d",
	"latin-extended-e",
	"variation-selectors",
	"vertical-forms",
	"combining-half-marks",
	"cjk-compatibility-forms",
	"small-form-variants",
	"halfwidth-and-fullwidth-forms",
	"specials",
	"latin-extended-f",
	"shorthand-format-controls",
	"musical-symbols",
	"musical-symbols-supplement",
	"tai-xuan-jing-symbols",
	"mathematical-alphanumeric-symbols",
	"miscellaneous-symbols-and-arrows-extended",
	"latin-extended-g",
	"cyrillic-extended-d",
	"mahjong-tiles",
	"domino-tiles",
	"playing-cards",
	"enclosed-alphanumeric-supplement",
	"enclosed-ideographic-supplement",
	"miscellaneous-symbols-and-pictographs",
	"emoticons",
	"ornamental-dingbats",
	"transport-and-map-symbols",
	"geometric-shapes-extended",
	"supplemental-arrows-c",
	"supplemental-symbols-and-pictographs",
	"chess-symbols",
	"symbols-and-pictographs-extended-a",
]);
